import React from 'react';
import { Icon } from '@gerdau/hefesto/Icon';

import { AttachmentsItemContainer, AttachmentsItemTitle } from './styles';

interface Props {
  title: string;
  href: string;
}

export const HelpCenterAttachmentsItem = ({ title, href }: Props) => {
  if (!title || !href) {
    return null;
  }

  return (
    <AttachmentsItemContainer
      rel="noopener noreferrer"
      target="_blank"
      href={href}
    >
      <AttachmentsItemTitle>{title}</AttachmentsItemTitle>
      <Icon option="Download" />
    </AttachmentsItemContainer>
  );
};
